import styled from 'styled-components';

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.15rem 1.25rem 1.5rem;
  color: ${(props) => props.theme.colors.onBackground};
`;

export const ProductHero = styled.div`
  align-items: center;
  background:
    radial-gradient(
      circle at top left,
      ${(props) => `${props.theme.colors.primary}1c`},
      transparent 42%
    ),
    linear-gradient(135deg, ${(props) => `${props.theme.colors.surface}`},
      ${(props) => `${props.theme.colors.primary}0b`});
  border: 1px solid ${(props) => `${props.theme.colors.primary}30`};
  border-radius: 1rem;
  box-sizing: border-box;
  display: grid;
  gap: 1rem;
  grid-template-columns: auto minmax(0, 1fr) auto;
  padding: 1rem;

  @media (max-width: 620px) {
    grid-template-columns: auto minmax(0, 1fr);
  }
`;

export const HeroCopy = styled.div`
  min-width: 0;

  h2,
  p {
    margin: 0;
  }
`;

export const HeroEyebrow = styled.p`
  color: ${(props) => props.theme.colors.primary};
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  margin-bottom: 0.35rem !important;
  text-transform: uppercase;
`;

export const HeroTitle = styled.h2`
  color: ${(props) => props.theme.colors.onSurface};
  font-size: 1.35rem;
  line-height: 1.3;
  overflow-wrap: anywhere;
`;

export const HeroCode = styled.p`
  color: ${(props) => props.theme.colors.textLight};
  font-size: 0.88rem;
  margin-top: 0.4rem !important;
`;

export const StatusBadge = styled.span<{ $active: boolean }>`
  align-items: center;
  background: ${(props) => `${props.$active
    ? props.theme.colors.positive
    : props.theme.colors.negative}18`};
  border: 1px solid ${(props) => `${props.$active
    ? props.theme.colors.positive
    : props.theme.colors.negative}45`};
  border-radius: 999px;
  color: ${(props) => (props.$active
    ? props.theme.colors.positive
    : props.theme.colors.negative)};
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 700;
  justify-content: center;
  min-width: 4.75rem;
  padding: 0.42rem 0.7rem;
  white-space: nowrap;

  @media (max-width: 620px) {
    grid-column: 2;
    justify-self: start;
  }
`;

export const DetailsSection = styled.section`
  background: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => `${props.theme.colors.onSurface}20`};
  border-radius: 1rem;
  box-shadow: 0 3px 14px ${(props) => `${props.theme.colors.onBackground}0c`};
  overflow: hidden;
`;

export const SectionHeader = styled.div`
  align-items: center;
  background: ${(props) => `${props.theme.colors.onSurface}06`};
  border-bottom: 1px solid ${(props) => `${props.theme.colors.onSurface}16`};
  display: flex;
  gap: 0.65rem;
  padding: 0.8rem 1rem;
`;

export const SectionAccent = styled.span`
  background: ${(props) => props.theme.colors.primary};
  border-radius: 999px;
  display: block;
  height: 1.25rem;
  width: 0.25rem;
`;

export const SectionIcon = styled.span`
  align-items: center;
  background: ${(props) => `${props.theme.colors.primary}14`};
  border-radius: 0.55rem;
  color: ${(props) => props.theme.colors.primary};
  display: inline-flex;
  height: 1.85rem;
  justify-content: center;
  width: 1.85rem;
`;

export const SectionTitle = styled.h3`
  color: ${(props) => props.theme.colors.onSurface};
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  margin: 0;
  text-transform: uppercase;
`;

export const FieldsGrid = styled.div`
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 1rem;

  @media (max-width: 1050px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const DetailFieldCard = styled.div`
  background: ${(props) => `${props.theme.colors.onSurface}05`};
  border: 1px solid ${(props) => `${props.theme.colors.onSurface}12`};
  border-radius: 0.7rem;
  box-sizing: border-box;
  min-width: 0;
  padding: 0.7rem 0.8rem;
  transition: border-color 0.18s ease, background 0.18s ease;

  &:hover {
    background: ${(props) => `${props.theme.colors.primary}08`};
    border-color: ${(props) => `${props.theme.colors.primary}35`};
  }
`;

export const FieldLabel = styled.p`
  color: ${(props) => props.theme.colors.textLight};
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.35;
  margin: 0 0 0.3rem;
`;

export const FieldValue = styled.p`
  color: ${(props) => props.theme.colors.onSurface};
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.45;
  margin: 0;
  overflow-wrap: anywhere;
`;

export const FieldStatusValue = styled(FieldValue)<{ $active: boolean }>`
  color: ${(props) => (props.$active
    ? props.theme.colors.positive
    : props.theme.colors.negative)};
`;
